























































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import AppConsts from "@/lib/appconst";
import ChangePasswordInfo from "@/store/entities/users/change-password";

import moment from "vue-moment";
Vue.use(require("vue-moment"));

@Component
export default class ChangePasswordComponent extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  changePassModel: ChangePasswordInfo = new ChangePasswordInfo();
  spinShow: boolean = false;
  passWordWarning:string="";
  created()
  {
    this.passWordWarning= Util.L("Warning.PasswordFormat");
  }
  validatePass(rule, value, callback) {
    if (value === "") {
      callback(
        new Error(this.L("Error.RequiredField0", undefined, this.L("Password")))
      );
    } else {
      if (this.changePassModel.confirmPassword !== "") {
        (this.$refs.changePasswordForm as any).validateField("confirmPassword");
      }
      callback();
    }
  }
  validatePassCheck(rule, value, callback) {
    if (value === "") {
      callback(
        new Error(
          this.L("Error.RequiredField0", undefined, this.L("ConfirmPassword"))
        )
      );
    } else if (value !== this.changePassModel.newPassword) {
      callback(new Error(this.L("ConfirmPasswordNotMatch")));
    } else {
      callback();
    }
  }
  logout() {
    this.$store.commit("app/logout", this);
    Util.abp.auth.clearToken();
    abp.multiTenancy.setTenantIdCookie(null);
    location.reload();
  }
  handleSubmit() {
    (this.$refs.changePasswordForm as any).validate(valid => {
      if (valid) {
        this.$Modal.confirm({
          title: this.L("Tips"),
          content: this.L("Confirm.ChangeUserPassword"),
          okText: this.L("Yes"),
          cancelText: this.L("No"),
          onOk: async () => {
            this.spinShow = true;
            try {
              await this.$store.dispatch({
                type: "user/changePassword",
                data: {
                 NewPassword: this.changePassModel.newPassword
                }
              });
              this.$Message.success(this.L("Success.ChangeUserPassword"));
              this.handleReset();
              this.spinShow = false;
              this.logout();
            } catch (error) {
              this.spinShow = false;
            }
          }
        });
      }
    });
  }
  handleReset() {
    (this.$refs.changePasswordForm as any).resetFields();
  }
  rules = {
    newPassword: [
      {
        required: true,
        message: this.L(
          "Error.RequiredField0",
          undefined,
          this.L("NewPassword")
        ),
        trigger: "blur"
      },
      { validator: this.validatePass, trigger: "blur" }
    ],
    confirmPassword: [
      {
        required: true,
        message: this.L(
          "Error.RequiredField0",
          undefined,
          this.L("ConfirmPassword")
        ),
        trigger: "blur"
      },
      { validator: this.validatePassCheck, trigger: "blur" }
    ]
  };
}
